import { FaPlus } from "react-icons/fa";
import { useState } from "react";
import {
  formatNumber,
  truncateToTwoDecimals,
} from "../../../../utility/helper";
import { useSelector } from "react-redux";
import OverviewSection from "./userHomeComponent/fortune";
import LegacyComponent from "./userHomeComponent/legacy/legacy";
import FortuneStatsSkeleton from "./userHomeComponent/fortuneStatsSkeleton";

export const HorizontalTabButtons = ({ buttons = [], selected, onSelect }) => (
  <div className="flex gap-5 items-baseline md:ml-28 overflow-y-auto w-[calc(100%-100px)] whitespace-nowrap">
    {buttons.map((btn) => {
      const isActive = btn.isActive === "true";
      const isSelected = selected === btn.name;

      return (
        <button
          key={btn.name}
          className={`font-normal transition-all duration-200 ${
            isSelected
              ? "text-lightPrimary dark:text-primary-gradient text-lg"
              : isActive
              ? "text-info dark:text-grey text-sm hover:text-lightPrimary dark:hover:text-primary-gradient"
              : "text-gray-400 cursor-not-allowed text-sm"
          }`}
          onClick={() => {
            if (isActive) {
              onSelect(btn.name);
            }
          }}
          disabled={!isActive}
          title={!isActive ? "This tab is currently disabled" : ""}
        >
          {btn.name}
        </button>
      );
    })}
  </div>
);

const Home = ({
  handleIconClick,
  handleOptionSelect,
  fortuneData,
  allAssetsData,
  leagcyData,
}) => {
  const [selectedButton, setSelectedButton] = useState("Fortune");
  const { currency } = useSelector((state) => state.user);

  const tabOptions = [
    { name: "Fortune", isActive: "true" },
    // { name: "Return", isActive: "false" },
    // { name: "Movements", isActive: "false" },
    // { name: "Documents", isActive: "false" },
    { name: "Legacy", isActive: "true" },
  ];
  const isLoading = useSelector((state) => state.loader.loadingCount > 0);

  return (
    <>
      <div className="font-bold w-full flex items-center flex-row justify-between px-4">
        <HorizontalTabButtons
          buttons={tabOptions}
          selected={selectedButton}
          onSelect={setSelectedButton}
        />

        {allAssetsData?.length > 0 && (
          <button
            onClick={handleIconClick}
            className="flex items-center justify-center w-10 h-9 font-bold bg-[radial-gradient(circle_at_10%_10%,rgb(237,237,237),#9e9e9e,#9e9e9e,#9e9e9e)] rounded-md border border-lightPrimary dark:border-none shadow-inner hover:bg-gray-500 text-lightPrimary dark:text-black dark:button-primary-gradient rounded-md"
          >
            <FaPlus />
          </button>
        )}
      </div>
      {isLoading ? (
        <FortuneStatsSkeleton />
      ) : (
        <div className="relative border w-full border-lightPrimary/40 dark:border-info/40 p-6 mx-4 my-3 rounded-sm dark:bg-card-custom-radials bg-[length:100%_200%] bg-white">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-sm text-info dark:text-grey overflow-y-auto">
            <div className="space-y-4 w-full max-w-[20rem]">
              <div className="items-baseline">
                <span>Total Fortune Value:</span>
                <div
                  className={`text-2xl font-medium break-anywhere ${
                    parseFloat(fortuneData?.fortune ?? 0) < 0
                      ? "text-expense dark:text-warning"
                      : "text-lightPrimary dark:text-primary-gradient"
                  }`}
                >
                  {formatNumber(
                    truncateToTwoDecimals(Number(fortuneData?.fortune ?? "0"))
                  )}{" "}
                  {currency ? currency : ""}
                </div>
              </div>
              <div className="items-baseline">
                <span>
                  Fortune has{" "}
                  {parseFloat(fortuneData?.fortune_increased ?? 0) < 0
                    ? "decreased"
                    : "increased"}{" "}
                  by:
                </span>
                <div
                  className={`text-2xl font-medium break-anywhere ${
                    parseFloat(fortuneData?.fortune_increased ?? 0) < 0
                      ? "text-expense dark:text-warning"
                      : "text-lightPrimary dark:text-primary-gradient"
                  }`}
                >
                  {formatNumber(
                    truncateToTwoDecimals(
                      Math.abs(Number(fortuneData?.fortune_increased ?? "0"))
                    )
                  )}{" "}
                  {currency ? currency : ""}
                </div>
              </div>
              <div className="items-baseline">
                <span>
                  Due to total{" "}
                  {parseFloat(fortuneData?.total_profit ?? 0) < 0
                    ? "loss"
                    : "profit"}{" "}
                  of:
                </span>
                <div
                  className={`text-2xl font-medium break-anywhere ${
                    parseFloat(fortuneData?.total_profit ?? 0) < 0
                      ? "text-expense dark:text-warning"
                      : "text-lightPrimary dark:text-primary-gradient"
                  }`}
                >
                  {formatNumber(
                    truncateToTwoDecimals(
                      Math.abs(Number(fortuneData?.total_profit ?? "0"))
                    )
                  )}{" "}
                  {currency ? currency : ""}
                </div>
              </div>
            </div>

            <div className="flex flex-col justify-between space-y-4 text-sm w-full max-w-[25rem]">
              <div className="flex gap-4 items-baseline ">
                <span className="whitespace-nowrap">ROI:</span>
                <div
                  className={`text-2xl font-medium break-anywhere ${
                    parseFloat(fortuneData?.percentage_value ?? 0) < 0
                      ? "text-expense dark:text-warning"
                      : "text-lightPrimary dark:text-primary-gradient"
                  }`}
                >
                  {formatNumber(
                    truncateToTwoDecimals(
                      Math.abs(Number(fortuneData?.percentage_value ?? 0))
                    )
                  )}{" "}
                  %
                </div>
              </div>
              <div className="items-baseline">
                <span>
                  {parseFloat(fortuneData?.net_flow ?? 0) < 0
                    ? "And an outflow of:"
                    : "And an inflow of:"}
                </span>
                <div
                  className={`text-2xl font-medium break-anywhere ${
                    parseFloat(fortuneData?.net_flow ?? 0) < 0
                      ? "text-expense dark:text-warning"
                      : "text-lightPrimary dark:text-primary-gradient"
                  }`}
                >
                  {formatNumber(
                    truncateToTwoDecimals(
                      Math.abs(Number(fortuneData?.net_flow ?? 0))
                    )
                  )}{" "}
                  {currency || ""}
                </div>
              </div>
            </div>

            <div className="space-y-4 text-sm w-full max-w-[25rem]">
              <div className="flex w-full items-baseline gap-5">
                <span className="whitespace-nowrap">
                  Realised{" "}
                  {parseFloat(fortuneData?.realized ?? 0) < 0
                    ? "Loss"
                    : "profit"}
                  :{" "}
                </span>
                <span
                  className={`font-medium text-2xl break-anywhere ${
                    parseFloat(fortuneData?.realized ?? 0) < 0
                      ? "text-expense dark:text-warning"
                      : "text-lightPrimary dark:text-primary-gradient"
                  }`}
                >
                  {`${
                    fortuneData?.realized
                      ? formatNumber(
                          truncateToTwoDecimals(
                            Math.abs(Number(fortuneData.realized))
                          )
                        )
                      : "0"
                  } ${currency ? currency : ""}`}
                </span>
              </div>
              <div className="flex w-full items-baseline gap-2">
                <span className="whitespace-nowrap">
                  Unrealised{" "}
                  {parseFloat(fortuneData?.unrealized ?? 0) < 0
                    ? "Loss"
                    : "profit"}
                  :{" "}
                </span>
                <span
                  className={`font-medium text-2xl break-anywhere ${
                    parseFloat(fortuneData?.unrealized ?? 0) < 0
                      ? "text-expense dark:text-warning"
                      : "text-lightPrimary dark:text-primary-gradient"
                  }`}
                >
                  {fortuneData?.unrealized
                    ? `${formatNumber(
                        truncateToTwoDecimals(
                          Math.abs(Number(fortuneData?.unrealized))
                        )
                      )} ${currency ? currency : ""}`
                    : `0 ${currency ? currency : ""}`}
                </span>
              </div>
            </div>

            <div className="space-y-4 text-sm w-full">
              <div className="flex w-full gap-5 items-baseline">
                <span className="whitespace-nowrap">Income:</span>
                <span className="text-lightPrimary text-2xl dark:text-primary-gradient break-anywhere font-medium">
                  {`${
                    fortuneData?.income
                      ? formatNumber(
                          truncateToTwoDecimals(Number(fortuneData?.income))
                        )
                      : "0"
                  } ${currency ? currency : ""}`}
                </span>
              </div>
              <div className="flex w-full gap-4 items-baseline">
                <span className="whitespace-nowrap">Expense:</span>
                <span className=" text-2xl text-expense dark:text-warning break-anywhere font-medium">
                  {`${
                    fortuneData?.expense
                      ? formatNumber(
                          truncateToTwoDecimals(Number(fortuneData.expense))
                        )
                      : "0"
                  } ${currency ? currency : ""}`}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedButton === "Fortune" && (
        <OverviewSection
          isLoading={isLoading}
          allAssetsData={allAssetsData}
          handleOptionSelect={handleOptionSelect}
          handleIconClick={handleIconClick}
        />
      )}
      {selectedButton === "Legacy" && (
        <LegacyComponent
          leagcyData={leagcyData}
          handleOptionSelect={"handleOptionSelect"}
          loading={isLoading}
          confirmDelete={"confirmDelete"}
          // setLimit={setLimit}
          // limit={limit}
          // setPage={setPage}
          // page={page}
        />
      )}
    </>
  );
};

export default Home;
